import React from 'react';

interface ModalBodyProps {
  children: React.ReactNode;
  className?: string;
  noPadding?: boolean;
}

export function ModalBody({ 
  children, 
  className = '', 
  noPadding = false 
}: ModalBodyProps) {
  const paddingClass = noPadding ? '' : 'p-6';
  
  return (
    <div className={`flex-1 overflow-y-auto ${paddingClass} ${className}`}>
      {children}
    </div>
  );
}